<template>
  <div class="container" v-if="!store.loggedIn">
    <img class="logo" src="/static/img/KovoLogoPadding.svg" alt="">
    <div>
      <div class="welcomeContainer cardBackground">
        <h1>Welcome</h1>
        <div class="buttonContainer">
          <button class="specialButton registerButton" @click="goToRegister" style="color: var(--text-primary); background-color: var(--color-secondary-button)">Register</button>
          <div class="accountText">Already have an account?</div>
          <button class="specialButtonTransparent loginButton" @click="goToLogin" style="color: var(--text-primary); background-color: var(--color-secondary-button)">Login</button>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { useLoginStore } from "@/stores/loginStore";

export default {
  name: 'WelcomePage',
  data(){
    return {
      store: useLoginStore()
    }
  },
  mounted() {
    if (this.store.loggedIn){
      this.goToHome()
    } else if (this.store.pastLogging) {
      this.goToLogin()
    }
  },
  methods: {
    goToLogin(){
      this.$router.push({
        name: 'login'
      })
    },
    goToRegister(){
      this.$router.push({
        name: 'user-register'
      })
    },
    async goToHome(){
      this.$router.push({
        name: 'dashboard'
      })
    },
  },
}
</script>

<style scoped>
.logo {
  display: block;
  margin: 2rem auto;
  width: 100%;
  height: auto;
  margin-top: 7rem;
}
.welcomeContainer{
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin: 30px;
  max-width: 500px;
  border-radius: 12px;
  padding: 20px;
}
.buttonContainer{
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
}
.accountText{
  font-size: 18px;
  color: var(--text-primary);
  text-align: center;
}
.loginButton, .registerButton{
  width: 100%;
  max-width: 300px;
}
h1{
  text-align: center;
}
</style>